<template>
  <div id="app">
    <DeviseModal />
    <TermsOfUseModal />
    <ModalIframe />

    <MainHeader v-if="isNotInConfig" />

    <main>
      <router-view />
    </main>

    <MainFooter v-if="isNotInConfig" />
  </div>
</template>

<script>
import MainHeader from "./components/structure/MainHeader.vue";
import MainFooter from "./components/structure/MainFooter.vue";
import DeviseModal from "./components/devise/Modal.vue";
import TermsOfUseModal from "./components/devise/TermsOfUse.vue";
import AOS from "aos";
import "aos/dist/aos.css";
import ModalIframe from "./components/ModalIframe.vue";

export default {
  computed: {
    isNotInConfig() {
      if (this.$route.name == "capa-teste" || this.$route.name == "teste") {
        return false;
      } else {
        return true;
      }
    },
  },

  components: {
    MainHeader,
    MainFooter,
    DeviseModal,
    TermsOfUseModal,
    ModalIframe
  },

  created() {
    AOS.init({
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
    });

    // Se o id do primeiro estado não for um inteiro, quer dizer que está usando uma listagem de estados antiga, então devemos zerar para poder usar a nova
    let oldStates = localStorage.getItem("states");
    if (oldStates) {
      if (isNaN(JSON.parse(oldStates)[0]["id"])) {
        localStorage.removeItem("states");
      }
    }

    this.$store.dispatch("domains/getLocalDomains");
    this.$store.dispatch("location/setUserLocation", this.$geoip2);
    this.$store.dispatch("location/setStates");
    this.$store.dispatch("user/checkAuth");

    this.$EventBus.$on("checkTermsOfUse", () => {
      this.termsOfUse();
    });

    this.termsOfUse();
    this.hasSource();
  },

  destroyed() {
    this.$EventBus.$off("checkTermsOfUse");
  },

  methods: {
    termsOfUse() {
      if (this.$store.state.user.profile) {
        this.$store
          .dispatch(
            "graphql_queries/query",
            `
          user( id: "${this.$store.state.user.profile.id}" ){
            termsOfUserAccepted{ companyId },
            hasSubscriptions,
            followCompanies
          },
        `
          )
          .then((response) => {
            // Aceitou os termos DESSA empresa?
            if (
              response.user.termsOfUserAccepted &&
              !response.user.termsOfUserAccepted.find(
                (terms) => terms.companyId == this.$store.state.companyId
              ) &&
              !response.user.hasSubscriptions &&
              !response.user.followCompanies
            ) {
              this.$EventBus.$emit("showTermsOfUse");
            }
          });
      }
    },

    hasSource() {
      if (this.$route.query.source) {
        localStorage.setItem("source", this.$route.query.source);
      }
    },
  },
};
</script>

<style lang="scss">
@import "./assets/stylesheets/app.scss";
#app > .container-fluid {
  min-height: 80vh;
}
</style>
